<template>
  <el-table
    border
    size="small"
    width="100%"
    :data="data"
    :row-class-name="tableRowClassName"
    :span-method="spanMethod"
    :show-header="showHeader_fn()"
  >
    <el-table-column :resizable="false" :width="70" :label="startYear">
      <template slot-scope="scope">
        <template v-if="scope.row.day">
          {{ scope.row.dayDate }}<span>{{ scope.row.day }}</span>
        </template>
        <template v-else>
          {{ scope.row.dayDate }}
        </template>
      </template>
    </el-table-column>
    <el-table-column :resizable="false" width="55" :label="$locale('report.cinemaDaily.paidMobilization')" prop="paidMobilization"></el-table-column>
    <el-table-column :resizable="false" width="55" :label="$locale('report.cinemaDaily.freeMobilization')" prop="freeMobilization"></el-table-column>
    <el-table-column :resizable="false" width="80" :label="$locale('report.cinemaDaily.boxOfficeAmount')" prop="boxOfficeAmount"></el-table-column>
    <el-table-column :resizable="false" width="80" :label="$locale('report.cinemaDaily.budgetCompletionRate')" prop="ticketBudgetAchievementRate" :formatter="rateFormat"></el-table-column>
    <el-table-column :resizable="false" :label="$locale('report.cinemaDaily.incidental')">
      <el-table-column :resizable="false" width="70" :label="$locale('report.cinemaDaily.professional')" prop="programAmount"></el-table-column>
      <el-table-column :resizable="false" width="70" :label="$locale('report.cinemaDaily.goods')" prop="commercialAmount"></el-table-column>
      <el-table-column :resizable="false" width="70" :label="$locale('report.cinemaDaily.eating')" prop="concessionAmount"></el-table-column>
      <el-table-column :resizable="false" width="70" :label="$locale('report.cinemaDaily.membershipFree')" prop="membershipFreeAmount"></el-table-column>
      <el-table-column :resizable="false" width="70" :label="$locale('global.other')" prop="otherAmount"></el-table-column>
      <el-table-column :resizable="false" width="110" :label="$locale('global.total')" prop="totalAmount"></el-table-column>
    </el-table-column>
    <el-table-column :resizable="false" width="60" :label="$locale('report.cinemaDaily.budgetCompletionRate')" prop="goodsBudgetAchievementRate" :formatter="rateFormat"></el-table-column>
    <el-table-column :resizable="false" width="90" :label="$locale('report.cinemaDaily.advancePaymentDeposit')" prop="preSaleAmount"></el-table-column>
    <el-table-column :resizable="false" width="90" :label="$locale('report.cinemaDaily.dailyCash')" prop="dailyCash"></el-table-column>
    <el-table-column :resizable="false" width="90" :label="$locale('report.cinemaDaily.deposit')" prop="preCash"></el-table-column>
  </el-table>
</template>

<script>
export default {
  name: "cinemaDailyPdfTable",
  data() {
    return {}
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    startYear: {
      type: String,
      default: () => "",
    },
  },
  methods: {
    tableRowClassName({row}) {
      if (row.attach) {
        return "total" + row.attach
      }
    },
    spanMethod({ row, columnIndex }) {
      let obj = {
        rowspan: 1,
        colspan: 1,
      };

      if (row.attach) {
        if (row.attach == 2 || row.attach == 3) {
          if (columnIndex == 2) {
            obj.colspan = 3;
          } else if (columnIndex < 2) {
            obj.colspan = 0;
          }
        }

        if (row.attach == 4) {
          if (columnIndex == 4) {
            obj.colspan = 5;
          } else if (columnIndex < 4) {
            obj.colspan = 0;
          }
        }

        if (row.attach == 5) {
          if (columnIndex == 13) {
            obj.colspan = 2;
          } else if (columnIndex > 13) {
            obj.colspan = 0;
          }
        }
      }

      return obj;
    },
    rateFormat(row, column, cellValue, index) {
      switch(column.property) {
      case "ticketBudgetAchievementRate":
        return cellValue && !isNaN(cellValue) ? Math.round(cellValue * 100 * 100) / 100 + "%" : cellValue;
      case "goodsBudgetAchievementRate":
        return cellValue && !isNaN(cellValue) ? Math.round(cellValue * 100 * 100) / 100 + "%" : cellValue;
      default:
        return cellValue;
      }
    },
    showHeader_fn() {
      return !this.data.every(item => item.noHeaderData);
    }
  },
};
</script>
